import type { ObservableQuery } from '@apollo/client';
import type {
  GetFolderAssetsQuery,
  GetFolderAssetsQueryVariables,
} from '@frameio/assets/shared/gql/generated/GetFolderAssets';
import type {
  GetCollectionAssetsQuery,
  GetCollectionAssetsQueryVariables,
} from '@frameio/collections/gql/generated/GetCollectionAssets';
import type {
  GetFinderItemsQuery,
  GetFinderItemsQueryVariables,
  GetShareAssetsQuery,
  GetShareAssetsQueryVariables,
} from '@frameio/graphql-client/generated';
import type {
  GetTrashAssetsQuery,
  GetTrashAssetsQueryVariables,
} from '@frameio/trash/gql/generated/GetTrashAssets';

export type PossibleFinderQuery =
  | GetFinderItemsObservableQuery
  | GetCollectionAssetsObservableQuery
  | GetShareAssetsObservableQuery
  | GetFolderAssetsObservableQuery
  | GetTrashAssetsObservableQuery;

export type GetFinderItemsObservableQuery = ObservableQuery<
  GetFinderItemsQuery,
  GetFinderItemsQueryVariables
>;
export type GetCollectionAssetsObservableQuery = ObservableQuery<
  GetCollectionAssetsQuery,
  GetCollectionAssetsQueryVariables
>;
export type GetShareAssetsObservableQuery = ObservableQuery<
  GetShareAssetsQuery,
  GetShareAssetsQueryVariables
>;
export type GetFolderAssetsObservableQuery = ObservableQuery<
  GetFolderAssetsQuery,
  GetFolderAssetsQueryVariables
>;
export type GetTrashAssetsObservableQuery = ObservableQuery<
  GetTrashAssetsQuery,
  GetTrashAssetsQueryVariables
>;

export const isQueryGetFinderItems = (
  query: PossibleFinderQuery
): query is GetFinderItemsObservableQuery =>
  query.queryName === 'GetFinderItems';

export const isQueryGetCollectionAssets = (
  query: PossibleFinderQuery
): query is GetCollectionAssetsObservableQuery =>
  query.queryName === 'GetCollectionAssets';

export const isQueryGetShareAssets = (
  query: PossibleFinderQuery
): query is GetShareAssetsObservableQuery =>
  query.queryName === 'GetShareAssets';

export const isQueryGetFolderAssets = (
  query: PossibleFinderQuery
): query is GetFolderAssetsObservableQuery =>
  query.queryName === 'GetFolderAssets';

export const isQueryGetTrashAssets = (
  query: PossibleFinderQuery
): query is GetTrashAssetsObservableQuery =>
  query.queryName === 'GetTrashAssets';
